
import { Routes, Route } from 'react-router-dom'
import { List } from './components'

export const RoutesView = () => (
  <Routes>
    <Route path=":id" element={<List />} />
    <Route path="" element={<List />} />
  </Routes>
)
